<div class="mainSpacing">
  <div class="main-div-top">
    <div
      class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
    >
      <div class="m-0 p-0">
        <img [src]="piqetLogo" id="piqetLogo" alt="Piqet logo" />
      </div>
      <div class="m-0 pt-4 align-items-end">
        <img
          [src]="reportData?.organizationLogo"
          id="organizationLogo"
          alt="Organization image"
          align="right"
        />
      </div>
    </div>
  </div>

  <div class="main-contant">
    <div class="maintext-heading">
      <span class="purpleProjectName">{{ mainProjectName | titlecase }}</span>
      {{ remainingProjectName | titlecase }}
      -
      <br />
      {{ reportResource.lblDetailedReport }}
    </div>
  </div>

  <div class="bottom-contant">
    <div class="">Generated by</div>
    <div class="">George heathcote</div>
    <div class="">Other.side studio</div>
  </div>

  <div class="last-bottom-contant">
    <div class="">PIQET project code : {{ reportData?.projectCode }}</div>
    <div class="">Report generated : {{ getFormateDate(reportData?.reportGeneratedDate) }}</div>
    <div class="">Software version : PIQET {{ reportData?.softwareVersion }}</div>
  </div>

  <!-- <div class="row table-div" class="page-break content-page-main-title-space">
        <div class="col-12 table-content">
            <h1>Table of contents</h1>
            <br />
            <table class="table table-of-content">
                <tr>
                    <td align="left" class="heading">Glass Bottle</td>
                    <td align="left" class="heading">03</td>
                </tr>
                <tr>
                    <td align="left" class="heading">Material procurement and conversion</td>
                    <td align="left" class="heading">05</td>
                </tr>
                <tr>
                    <td align="left" class="heading">Graphical summary od results</td>
                    <td align="left" class="heading">11</td>
                </tr>
                <tr>
                    <td align="left" class="heading">Graphical summary od results</td>
                    <td align="left" class="heading">12</td>
                </tr>
            </table>
        </div>
    </div> -->

  <ng-container *ngIf="reportData.isIncludeInputInformation">
    <ng-container *ngIf="reportData.lstInputInfomation.length > 0; else other_lstInputInfomation">
      <div *ngFor="let inputInformationDetails of reportData.lstInputInfomation" #targetDivRef>
        <ng-container
          *ngIf="
            !!inputInformationDetails.lstSlidesDetailsReportModel &&
            inputInformationDetails.lstSlidesDetailsReportModel.length > 0
          "
        >
          <div class="page-break">
            <div>
              <img class="organizationLogo" [src]="reportData.organizationLogo" align="right" />
              <h3 class="content-page-main-title-space">
                {{ inputInformationDetails.scenarioName }}
              </h3>
              <p class="tableHeading">Input Information</p>
            </div>
          </div>

          <div class="row table-div">
            <div class="col-12 table-content">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td><span>Name of the component</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.componanetName != null && item.componanetName != '';
                          else cheked_componentName
                        "
                      >
                        <span>{{ item.componanetName }}</span>
                      </td>
                      <ng-template #cheked_componentName>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Supplier</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="item.supplier != null && item.supplier != ''; else cheked_supplier"
                      >
                        <span>{{ item.supplier }}</span>
                      </td>
                      <ng-template #cheked_supplier>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Weight of package (kg)</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.weightofPackage != null && item.weightofPackage != '';
                          else cheked_weightofPackage
                        "
                      >
                        <span>{{ item.weightofPackage }}</span>
                      </td>
                      <ng-template #cheked_weightofPackage>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Raw material</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.rawMaterial != null && item.rawMaterial != '';
                          else cheked_rawMaterial
                        "
                      >
                        <span>{{ item.rawMaterial }}</span>
                      </td>
                      <ng-template #cheked_rawMaterial>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Recycled content (%)</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td *ngIf="item.recycledContent > 0; else cheked_recycledContent">
                        <span>{{ item.recycledContent }}</span>
                      </td>
                      <ng-template #cheked_recycledContent>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Raw material region</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.rawMaterialCountryofOrigin != null &&
                            item.rawMaterialCountryofOrigin != '';
                          else cheked_rawMaterialCountryofOrigin
                        "
                      >
                        <span>{{ item.rawMaterialCountryofOrigin }}</span>
                      </td>
                      <ng-template #cheked_rawMaterialCountryofOrigin>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Transport to converter (km)</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.rawMaterialTransport != null && item.rawMaterialTransport != '';
                          else cheked_rawMaterialTransport
                        "
                      >
                        <span>{{ item.rawMaterialTransport }}</span>
                      </td>
                      <ng-template #cheked_rawMaterialTransport>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Conversion</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.conversion != null && item.conversion != '';
                          else cheked_conversion
                        "
                      >
                        <span>{{ item.conversion }}</span>
                      </td>
                      <ng-template #cheked_conversion>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Transport to filler (km)</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.transporttoFiller != null && item.transporttoFiller != '';
                          else cheked_transporttoFiller
                        "
                      >
                        <span>{{ item.transporttoFiller }}</span>
                      </td>
                      <ng-template #cheked_transporttoFiller>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Country of conversion</span></td>
                    <ng-container
                      *ngFor="let item of inputInformationDetails.lstSlidesDetailsReportModel"
                    >
                      <td
                        *ngIf="
                          item.countryofConversion != null && item.countryofConversion != '';
                          else cheked_countryofConversion
                        "
                      >
                        <span>{{ item.countryofConversion }}</span>
                      </td>
                      <ng-template #cheked_countryofConversion>
                        <td align="center"></td>
                      </ng-template>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Filler region</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.fillingRegion != null && item.fillingRegion != '';
                            else cheked_fillingRegion
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.fillingRegion }}</span>
                        </td>
                        <ng-template #cheked_fillingRegion>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Filler process</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.fillingProcess != null && item.fillingProcess != '';
                            else cheked_fillingProcess
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.fillingProcess }}</span>
                        </td>
                        <ng-template #cheked_fillingProcess>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <!-- Display if don't include product info -->
                  <ng-container *ngIf="reportData.isProductContent">
                    <tr>
                      <td><span>Product</span></td>
                      <ng-container
                        *ngFor="
                          let item of inputInformationDetails.lstSlidesDetailsReportModel;
                          let i = index
                        "
                      >
                        <ng-container *ngIf="i == 0">
                          <td
                            *ngIf="item.product != null && item.product != ''; else cheked_product"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          >
                            <span>{{ item.product }}</span>
                          </td>
                          <ng-template #cheked_product>
                            <td
                              align="center"
                              [attr.colspan]="
                                inputInformationDetails.lstSlidesDetailsReportModel.length
                              "
                            ></td>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </tr>
                    <tr>
                      <td><span>Product quantity (ml)</span></td>
                      <ng-container
                        *ngFor="
                          let item of inputInformationDetails.lstSlidesDetailsReportModel;
                          let i = index
                        "
                      >
                        <ng-container *ngIf="i == 0">
                          <td
                            *ngIf="item.productQty > 0; else cheked_productQty"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          >
                            <span>{{ item.productQty }}</span>
                          </td>
                          <ng-template #cheked_productQty>
                            <td
                              align="center"
                              [attr.colspan]="
                                inputInformationDetails.lstSlidesDetailsReportModel.length
                              "
                            ></td>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </tr>
                    <tr>
                      <td><span>Product density (kg/l)</span></td>
                      <ng-container
                        *ngFor="
                          let item of inputInformationDetails.lstSlidesDetailsReportModel;
                          let i = index
                        "
                      >
                        <ng-container *ngIf="i == 0">
                          <td
                            *ngIf="item.productDensity > 0; else cheked_productDensity"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          >
                            <span>{{ item.productDensity }}</span>
                          </td>
                          <ng-template #cheked_productDensity>
                            <td
                              align="center"
                              [attr.colspan]="
                                inputInformationDetails.lstSlidesDetailsReportModel.length
                              "
                            ></td>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </tr>
                    <tr>
                      <td><span>Functional units per product</span></td>
                      <ng-container
                        *ngFor="
                          let item of inputInformationDetails.lstSlidesDetailsReportModel;
                          let i = index
                        "
                      >
                        <ng-container *ngIf="i == 0">
                          <td
                            *ngIf="
                              item.functionalUnitPerProduct > 0;
                              else cheked_functionalUnitPerProduct
                            "
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          >
                            <span>{{ item.functionalUnitPerProduct }}</span>
                          </td>
                          <ng-template #cheked_functionalUnitPerProduct>
                            <td
                              [attr.colspan]="
                                inputInformationDetails.lstSlidesDetailsReportModel.length
                              "
                            >
                              1
                            </td>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </ng-container>
                  <tr>
                    <td><span>Transport to wholesale (km)</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.transporttoWholesale != null && item.transporttoWholesale != '';
                            else cheked_transporttoWholesale
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.transporttoWholesale }}</span>
                        </td>
                        <ng-template #cheked_transporttoWholesale>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Wholesale region</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.wholesaleRegion != null && item.wholesaleRegion != '';
                            else cheked_wholesaleRegion
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.wholesaleRegion }}</span>
                        </td>
                        <ng-template #cheked_wholesaleRegion>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Wholesale storage</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.wholesaleStorage != null && item.wholesaleStorage != '';
                            else cheked_wholesaleStorage
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.wholesaleStorage }}</span>
                        </td>
                        <ng-template #cheked_wholesaleStorage>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Transport to retail (km)</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                          *ngIf="
                            item.transporttoRetail != null && item.transporttoRetail != '';
                            else cheked_transporttoRetail
                          "
                        >
                          <span>{{ item.transporttoRetail }}</span>
                        </td>
                        <ng-template #cheked_transporttoRetail>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Retail region</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.retailRegion != null && item.retailRegion != '';
                            else cheked_retailRegion
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.retailRegion }}</span>
                        </td>
                        <ng-template #cheked_retailRegion>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Retail storage</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.retailStorage != null && item.retailStorage != '';
                            else cheked_retailStorage
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.retailStorage }}</span>
                        </td>
                        <ng-template #cheked_retailStorage>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Transport to consumer (km)</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                          *ngIf="
                            item.transporttoConsumer != null && item.transporttoConsumer != '';
                            else cheked_transporttoConsumer
                          "
                        >
                          <span>{{ item.transporttoConsumer }}</span>
                        </td>
                        <ng-template #cheked_transporttoConsumer>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Consumer region</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.consumerRegion != null && item.consumerRegion != '';
                            else cheked_consumerRegion
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.consumerRegion }}</span>
                        </td>
                        <ng-template #cheked_consumerRegion>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>Consumer storage</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.consumerStorage != null && item.consumerStorage != '';
                            else cheked_consumerStorage
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.consumerStorage }}</span>
                        </td>
                        <ng-template #cheked_consumerStorage>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <td><span>End-of-life scenario</span></td>
                    <ng-container
                      *ngFor="
                        let item of inputInformationDetails.lstSlidesDetailsReportModel;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="i == 0">
                        <td
                          *ngIf="
                            item.fillingProcess != null && item.fillingProcess != '';
                            else cheked_FillingProcess
                          "
                          [attr.colspan]="
                            inputInformationDetails.lstSlidesDetailsReportModel.length
                          "
                        >
                          <span>{{ item.fillingProcess }}</span>
                        </td>
                        <ng-template #cheked_FillingProcess>
                          <td
                            align="center"
                            [attr.colspan]="
                              inputInformationDetails.lstSlidesDetailsReportModel.length
                            "
                          ></td>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #other_lstInputInfomation>
      <div class="row table-div" class="page-break">
        <div class="col-12 table-content">
          <table class="table">
            <tr>
              <td align="center">No component records found.</td>
            </tr>
          </table>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <div
    *ngFor="let item of reportData.packageDetalsModels; let i = index; let evenMain = even"
    style="margin: 40px 0px"
  >
    <ng-container
      *ngIf="item.packageName != null && item.packageName != ''; else cheked_packageName"
    >
      <div *ngIf="reportData.isIncludeInputInformation; else other_data">
        <div>
          <img [src]="reportData.organizationLogo" align="right" class="organizationLogo" />
          <!-- <div class="tableHeading">Material procurement and conversion</div> -->
        </div>
      </div>
      <ng-template #other_data>
        <div>
          <div *ngIf="i + 1 > 1; else cheked_Ivalue">
            <div>
              <img [src]="reportData.organizationLogo" class="organizationLogo" align="right" />
              <!-- <div class="tableHeading">Material procurement and conversion</div> -->
            </div>
          </div>
          <ng-template #cheked_Ivalue>
            <div>
              <div>
                <img [src]="reportData.organizationLogo" class="organizationLogo" align="right" />
                <!-- <div class="tableHeading">Material procurement and conversion</div> -->
              </div>
            </div>
          </ng-template>
        </div>
      </ng-template>

      <div>
        <div class="tableHeading page-break" *ngIf="i % 2 == 0 || i == 0">
          Material procurement and conversion
        </div>
        <h1 class="subHeading">{{ item.packageName }}</h1>
        <ng-container
          *ngFor="let items of item.packageMaterialsDetalsModels; let k = index; let even = even"
        >
          <!-- <div style="display: none;">{{counterMaterial + 1}}</div> -->
          <p class="subsubhead">{{ items.componentName }}</p>
          <p class="heading">Material Transportation -</p>
          <p style="font-size: 16px">
            {{ items.materialName }} procured in {{ items.materialorigin }}

            <span *ngIf="items.conversioncountry != null && items.conversioncountry != ''">
              ----------- > Converted in
              {{ items.conversioncountry }}
            </span>

            <span *ngIf="items.filingProcessCountry != null && items.filingProcessCountry != ''">
              ----------- > Transported to
              {{ items.filingProcessCountry }} for packing
            </span>
          </p>

          <ng-container
            *ngIf="
              (items.mainMaterial != null && items.mainMaterial != '') ||
              (items.conversionProcess != null && items.conversionProcess != '')
            "
          >
            <ng-container *ngIf="items.stageProcess == 0; else checked_stageProcessone"
              ><br />
              <p class="heading">Material processing (1 stage process) -</p>
            </ng-container>
            <ng-template #checked_stageProcessone
              ><br />
              <p class="heading">Material processing ({{ items.stageProcess }} stage process) -</p>
            </ng-template>
            <p style="font-size: 16px">
              {{ items.mainMaterial }} made ----------- >
              {{ items.conversionProcess }}
            </p>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <!-- <hr> -->
    <ng-template #cheked_packageName>
      <div>
        <h1 class="subHeading">{{ item.packageName }}</h1>
        <div
          *ngFor="let items of item.packageMaterialsDetalsModels; let k = index; let even = even"
        >
          <div class="tableHeading page-break" *ngIf="i % 2 == 0 || i == 0">
            Material procurement and conversion
          </div>
          <ng-container>
            <!-- need to add counterMaterial = 1 -->
            <br />
            <p class="subsubhead">{{ items.componentName }}</p>

            <p class="heading">Material Transportation -</p>
            <p style="font-size: 16px">
              {{ items.materialName }} procured in {{ items.materialorigin }}
              <span *ngIf="items.conversioncountry != null && items.conversioncountry != ''">
                ----------- > Converted in
                {{ items.conversioncountry }}
              </span>
              <span *ngIf="items.filingProcessCountry != null && items.filingProcessCountry != ''">
                ----------- > Transported to
                {{ items.filingProcessCountry }} for packing
              </span>
            </p>

            <ng-container
              *ngIf="
                (items.mainMaterial != null && items.mainMaterial != '') ||
                (items.conversionProcess != null && items.conversionProcess != '')
              "
            >
              <ng-container *ngIf="items.stageProcess == 0; else checked_stageProcesstwo"
                ><br />
                <p class="heading">Material processing (1 stage process) -</p>
              </ng-container>
              <ng-template #checked_stageProcesstwo
                ><br />
                <p class="heading">
                  Material processing ({{ items.stageProcess }} stage process) -
                </p>
              </ng-template>
              <p style="font-size: 16px">
                {{ items.mainMaterial }} made ----------- >
                {{ items.conversionProcess }}
              </p>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Spider chart -->
  <div *ngIf="reportData.indicatorItems.length > 2">
    <div class="page-break">
      <img [src]="reportData.organizationLogo" align="right" class="organizationLogo" />
      <div class="tableHeading">At a glance comparison</div>
    </div>
    <br />
    <div class="reportContent" id="reportContentDiv">
      <br />
      <p style="font-size: 16px">
        <b>Note: </b>Spider diagram below shows relative impacts of scenarios being compared; closer
        to the centre, lesser is the environmental impact.
      </p>
      <div class="row space">
        <!-- renderer spider chart -->
        <canvas
          baseChart
          class="setspiderChart"
          [datasets]="spiderChartData"
          [type]="'radar'"
          [labels]="spiderChartLabels"
          [options]="spiderChartOptions"
          [plugins]="doughnutChartPlugins"
        >
        </canvas>
      </div>
    </div>
  </div>

  <!-- GRAPHICAL SUMMARY OF RESULTS -->
  <div class="page-break" style="margin-top: 30px">
    <img [src]="reportData.organizationLogo" align="right" class="organizationLogo" />
    <div class="tableHeading">Graphical summary of results</div>
  </div>
  <br />
  <div class="row table-div" style="margin-top: 5%" *ngFor="let data of allBarChartDara">
    <canvas
      baseChart
      [datasets]="data"
      [labels]="mbarChartLabels"
      [options]="barChartOptions"
      height="550"
      width="1030"
      [type]="'bar'"
    ></canvas>
  </div>

  <!-- <div class="page-break" *ngIf="isShowGraphicalSummary">
        <img [src]="reportData.organizationLogo" align="right" class="organizationLogo" />
        <h1 class="headingTitle">Graphical summary of results</h1>
    </div>
    <br />
    <div class="row table-div" style="page-break-after: always;margin-top: 5%;">
        <canvas baseChart [datasets]="barChartData" [labels]="mbarChartLabels" [options]="barChartOptions" height="550"
        width="1030" [type]="'bar'"></canvas>
    </div> -->
  <ng-container *ngIf="reportData.spiderChartItems.scenarioListForAnnumImpact.length > 0">
    <ng-container
      *ngFor="let scenario of reportData.spiderChartItems.scenarioListForAnnumImpact; let i = index"
    >
      <ng-container *ngIf="scenario.scenarioname != reportData.baseScenarioFullName">
        <ng-container *ngIf="scenario.scenarioFullName != reportData.baseScenarioFullName">
          <div>
            <div>
              <img [src]="reportData.organizationLogo" align="right" />
              <div class="tableHeading page-break">
                Summary - {{ scenario.scenarioFullName }} vs
                {{ reportData.baseScenarioName }} (Baseline)
              </div>
            </div>
            <br />
            <ng-container
              *ngFor="let childScenario of scenario.indicators.split(';'); let k = index"
            >
              <div>
                <ul class="plusIcon">
                  <li class="custom-list-item">
                    <span>{{ scenario.scenarioFullName }}</span> has a
                    <ng-container
                      *ngIf="baseTotal != null && baseTotal.length > 0; else other_baseTotal"
                    >
                      <ng-container
                        *ngIf="
                          scenarioTotalShowHide(scenario.totals.split(';'), k);
                          else otherScenario
                        "
                      >
                        <span>lower</span>
                      </ng-container>
                      <ng-template #otherScenario>
                        <span>higher</span>
                      </ng-template>
                    </ng-container>
                    <ng-template #other_baseTotal>
                      <span>higher</span>
                    </ng-template>
                    <span>
                      impact on {{ scenario.indicators.split(';')[k] }} than
                      {{ reportData.baseScenarioName }}</span
                    >
                  </li>
                </ul>
              </div>
            </ng-container>

            <div class="row table-div">
              <div class="col-12 table-content">
                <table class="table" align="center">
                  <ng-container *ngIf="scenario.scenarioname != reportData.baseScenarioFullName">
                    <tr class="indicatorsName" style="margin: 12px 0px">
                      <ng-container
                        *ngFor="let indicator of scenario.indicators.split(';'); let k = index"
                      >
                        <div class="subIndicator">
                          <td class="borderRemove">
                            <h4>{{ scenario.indicators.split(';')[k] }}</h4>
                          </td>
                        </div>
                      </ng-container>
                    </tr>
                    <tr class="indicatorsName">
                      <div *ngFor="let indicator of scenario.indicators.split(';'); let j = index">
                        <td class="borderRemove">
                          <div class="card card-indicator">
                            <div class="container">
                              <table class="cardTbl">
                                <tr>
                                  <div>
                                    <p>
                                      <span>
                                        Percentage reduction from replacing
                                        {{ reportData.baseScenarioName }} with
                                        {{ scenario.scenarioFullName }}</span
                                      >
                                    </p>
                                  </div>
                                </tr>
                                <tr>
                                  <div style="margin: 10px 0px">
                                    <ng-container
                                      *ngIf="
                                        scenario.scenarioname == reportData.baseScenarioFullName;
                                        else secondCondi
                                      "
                                    >
                                      <span>
                                        <b>baseline</b>
                                      </span>
                                    </ng-container>
                                    <ng-template #secondCondi>
                                      <ng-container
                                        *ngIf="
                                          getTotalImpactValue(j, scenario.totals.split(';')) >= 0;
                                          else thirdCondi
                                        "
                                      >
                                        <span class="getTotalImpact">
                                          <b>{{ getTotalImpact() }} %</b>
                                          <!-- need to add path -->
                                          <img
                                            height="22"
                                            width="22"
                                            style="vertical-align: middle; margin-bottom: 10px"
                                            src="./assets/images/UP.svg"
                                          />
                                        </span>
                                      </ng-container>
                                      <ng-template #thirdCondi>
                                        <span class="getTotalImpact">
                                          <b>{{ getTotalImpact() }} %</b>
                                          <!-- need to add path -->
                                          <img
                                            height="22"
                                            width="22"
                                            style="vertical-align: middle; margin-bottom: 10px"
                                            src="./assets/images/Down.svg"
                                          />
                                        </span>
                                      </ng-template>
                                    </ng-template>
                                  </div>
                                </tr>
                                <tr>
                                  <div class="annualText">Annually Equivalent to</div>
                                </tr>
                                <tr style="position: relative; bottom: 8px">
                                  <div style="margin: 8px 0px">
                                    <b class="impactText">{{
                                      getEquivalentImpactValue(
                                        j,
                                        scenario.totals.split(';'),
                                        scenario.multiplier.split(';')
                                      )
                                    }}</b>
                                  </div>
                                </tr>
                                <tr class="equivalencytext">
                                  <div *ngIf="!!equivalancyUnitlist">
                                    <span>{{ getEquivalancyname(equivalancyUnitlist[j]) }}</span>
                                  </div>
                                </tr>
                                <tr class="imageList">
                                  <div>
                                    <img [src]="imagelist[j]" />
                                  </div>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </td>
                      </div>
                    </tr>
                  </ng-container>
                </table>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
